module.exports = __webpack_public_path__ + "static/media/empty-icon.ba95592e.png";